"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeDark = exports.themeDefault = exports.COLORS = exports.FONT = void 0;
var FONT;
(function (FONT) {
    FONT["CascadiaCode"] = "Cascadia Code";
    FONT["SegoeUI"] = "Segoe UI";
})(FONT = exports.FONT || (exports.FONT = {}));
exports.COLORS = {
    LIGHT_BLUE: "#f3f6f9",
    PRIMARY: "#14B1AB",
    "PRIMARY:HOVER": "#34c3bd",
    "PRIMARY:ACTIVE": "#12a6a0",
    WARNING: "rgb(255, 171, 0)",
    "WARNING:HOVER": "#ffb92c",
    "WARNING:ACTIVE": "#ffaa00",
    DANGER: "rgb(222, 53, 11)",
    "DANGER:HOVER": "#e25533",
    "DANGER:ACTIVE": "#b92502",
    SUCCESS: "#E0F2E7",
    "SUCCESS:HOVER": "#c8f5d9",
    "SUCCESS:ACTIVE": "#E0F2E7",
    INFO: "#DDEBF6",
    "INFO:HOVER": "#bedff9",
    "INFO:ACTIVE": "#DDEBF6",
};
const styleDefault = {
    buttons: {
        height: 32,
        fontSize: 14,
        lightHeight: "32px",
        fontWeight: 500,
        cursor: "pointer",
        padding: "0px 10px",
        transition: "background .2s",
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        ":focus": {
            outlineColor: "rgba(0,0,0,.2)",
        },
        ":disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
            textDecoration: 'line-through'
        }
    },
};
const mixinButtonAction = (COLOR) => ({
    ":hover": {
        background: exports.COLORS[`${COLOR}:HOVER`],
    },
    ":active": {
        background: exports.COLORS[`${COLOR}:ACTIVE`],
        boxShadow: "0 0 2px 2px #eee",
    },
});
exports.themeDefault = {
    color: {
        primary: "#14B1AB",
        white: "#fff",
    },
    buttons: {
        default: Object.assign(Object.assign({}, styleDefault.buttons), { color: "#000", bg: "primary", ":hover": {
                background: "rgba(0,0,0,.1)",
            }, ":active": {
                background: "rgba(0,0,0,.2)",
                boxShadow: "0 0 2px 2px #eee",
            } }),
        primary: Object.assign(Object.assign(Object.assign({}, styleDefault.buttons), { color: "white", bg: exports.COLORS.PRIMARY, ":hover": {} }), mixinButtonAction("PRIMARY")),
        dark: Object.assign(Object.assign({}, styleDefault.buttons), { color: "#eee", bg: "#222", ":hover": {
                background: "#333",
            }, ":active": {
                background: "#000",
            } }),
        warning: Object.assign(Object.assign(Object.assign({}, styleDefault.buttons), { color: "black", bg: exports.COLORS.WARNING }), mixinButtonAction("WARNING")),
        danger: Object.assign(Object.assign(Object.assign({}, styleDefault.buttons), { color: "white", bg: exports.COLORS.DANGER }), mixinButtonAction("DANGER")),
        outline: Object.assign(Object.assign({}, styleDefault.buttons), { color: "#000", background: "none", outline: "none", ":hover": {
                background: "rgba(0,0,0,.1)",
            }, ":active": {
                background: "rgba(0,0,0,.2)",
            } }),
        link: Object.assign(Object.assign({}, styleDefault.buttons), { background: "none", outline: "none", color: exports.COLORS.PRIMARY, ":hover": {
                // background: "rgba(0,0,0,.1)",
                color: "#03928d",
                textDecoration: "underline",
            } }),
        success: Object.assign(Object.assign(Object.assign({}, styleDefault.buttons), { bg: "#E0F2E7", color: "#20AE54" }), mixinButtonAction("SUCCESS")),
        info: Object.assign(Object.assign(Object.assign({}, styleDefault.buttons), { bg: "#DDEBF6", color: "#1D85E1" }), mixinButtonAction("INFO")),
    },
    heading: {
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
        color: "#000",
    },
    input: {
        border: "2px solid #eee",
        background: "#eee",
        borderRadius: 8,
        outlineColor: exports.COLORS.PRIMARY,
        fontSize: 14,
        padding: 10,
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
        "&.error": {
            outlineColor: exports.COLORS.PRIMARY,
            borderColor: exports.COLORS.DANGER,
        },
        ":focus.error": {
            borderColor: "#eee",
        },
        "&:disabled": {
            background: "#fff",
            backgroundImage: `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAYAAACqj0o2AAAABHNCSVQICAgIfAhkiAAABMlJREFUeF7t3U9rE0EUAPCZXYpam1Y8eOmpl4qCB6nopWAPSk2T/kt2E2wRGqkVFWnBiyiIYEEPigc/g5ds0INfwe9jU5si2GR8CaZNmk12Zt7sbiaZXLszu/vLezOzszMpJYhPxXVnGGNzY6XSJ0Q10kVZkcwQSuaoS2I5P3nPZuDi56jsHew7zjKltJDwvBXZOjDlmEeWCSMFmiOxnJ98YMtw/QXykq5IIRrAE8B6IAgjGsB2QGFEA9gJKIRoAP0BuRENYHdALkQD2BswENEABgP2RDSAfIBdEQ0gP6AvogEUA+xANIDigG2IBlAO8BjRAMoDNhANIA6QJZNn6L7rzo573k/MtJRs2X6azpK5B5bPXzmsVqeFZ3FkTuZXRnfAPcdxbUIuJ0ql3VgQdQc8dN2bVUJew4R0fWJWfD4RG4m6A5YzmRSx7bUJz1tvWkQaiboDVrLZhZptP0gUi/dbgykyRN0BDzKZO8y2XUjhx6ezMRJE7QEdZ4dZVgIi8J1fcxY6ou6AkMI3qrb9ZrxYXOrWH4SKOACA12uW9bbZC0eOqDvggetu1CjN9IrAUHtn7QEdZ90i5OJoqfSFZ0inPJ11B/zturcZpS94IjCUSNQd8E8+P33E2OexYjHFE4HKEXUHhImYJUjLhzJri5Sk8zADKnl21h2w4jhp6IXrq9uyIims7LFPd0BMCitB1B2wks8nq7VaDiakC7IRiOpYdAdUFYHSiAawM26FemcD6J/43IgGsHvLyYVoAHt3PYGIBjC47+6JqDtgOZudtyhdgNea28EU8kd0RdQdUPUwphexL6IBFIvKDkQDKAbYMQGhOyDsNUzVGFuHNnBNnEK+xHEk6g4YZRvo+97ZAMpHYSOddQeEYcyCbds5mNLfwFHIl6awZ3gWtrvGsj6xdburzC3EmcL162XfJ2C/M5Xf7yxz021lWvYLy9QVO+C3C439zjSzJ7ffWeamBxWwY4iDxuGpABmBZde9B49yi7C46BnP6VQfw1oisFl34ASE0otAAvZTCre6RIeIBKzkcotVxjbhnUhjiW/UH78IjDYSkYAQgasEXmuKLO1QidwLMJo2EQkI74WfwgLLURgHflQJw1tXEGD4iHjAdJXSx5DCi7w3rfI4HsBwEbGA9TaQkEf9msLhdyxIwMNs9taRZb3qx07EL9LV985IQFiheo0Rshu0xFdl2rbWxZvC4UUiErBfx4FBX5i6SBxSQHUdyxADqkFEAvrtlQtKH5V/l2kDT58fl85IQF3bQHWIBvDYUi4SkYAHsDIBtjmEvjKhW9qrSGHcEAcJ2M+zMbJtrVgkYgFhkXnVsrZ0eJQTAeVHRALCk8g2PIlc9dsvLHLBsseqTmHxdEYCNrY5WFYKpvSfyCJgyoUJyDdORALWhzEwobo5aCnMH4lIQLa6eqkyMvIVJlTvYiJJtmzYEdi8ru5tIhKwHoGw3XVrzPPSsgiYclEBdk9nBYCymw0xcM2yUQL6IyIB6wNpalnp8573XAWIaB1RA3YiIgEH5VlY9Is7aRORgOVcbt5iLAnjwB3Ri1BxfBwR2N6xIAGHNQJPEA0gOhEorBGchX+HIbU+EX69bfKIkKnYfn/xx7lJ8vfsFM38krp+tN7/Cv4BNWiqLZxJ38kAAAAASUVORK5CYII=)`,
            backgroundSize: "60px",
            color: "#aaa",
        },
    },
    textarea: {
        border: "1px solid #eee",
        background: "#eee",
        borderRadius: 8,
        outlineColor: exports.COLORS.PRIMARY,
        fontSize: 14,
        padding: 10,
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
        ":focus": {
            background: "#fff",
        },
    },
    text: {
        muted: {
            color: "#999",
            fontSize: 14,
        },
        label: {
            fontSize: 12,
            fontWeight: 500,
        },
    },
    radio: {
        color: "primary",
    },
    forms: {},
    drawer: {
        background: "#fff",
        a: {
            color: "#111 !important",
        },
    },
    top_navigation: {
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.02)",
        borderBottom: "1px solid #efefef",
    },
    action_menu: {
        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
        background: "#fff",
    },
};
exports.themeDark = Object.assign(Object.assign({}, exports.themeDefault), { navigation: {
        background: "#161b22",
        color: "#eee",
    }, drawer: {
        background: "#222",
        color: "#eee",
        a: {
            color: "#eaeaea !important",
        },
    }, top_navigation: {
        backgroundColor: "#222",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.02)",
        borderBottom: "1px solid #333",
        color: "#eee",
    }, action_menu: {
        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
        background: "#111",
    } });
//# sourceMappingURL=theme.js.map